<div [class]="checkpointStatus()" class="checkpoint-container p-2 mb-3">
    <h3>
        <b class="curpoint" routerLink="/{{Routenames.platforms}}/{{platform().id}}">{{platform().name}}</b>
    </h3>
    <h4>
        <div class="d-flex gap-2">
            <b>{{checkpoint().name}} : </b>
            <b>
                <a href="{{checkpoint().url}}" id="checkpoint-{{checkpoint().id}}" target="_blank">
                    {{checkpoint().url | urlPrefixStripping}}
                </a>
            </b>
            <a class="text-dark" href="{{checkpoint().url}}" target="_blank">
                <mat-icon class="align-bottom" fontIcon="fa-up-right-from-square" fontSet="fas" style="padding-top: 0.2rem"></mat-icon>
            </a>
        </div>
    </h4>
    <div class="row py-2">
        <div class="col">
            <div><strong>Level</strong></div>
            <span>{{checkpoint().level}}</span>
        </div>
        <div class="col">
            <div><strong>Responsecode</strong></div>
            <span>{{checkpoint().valid_response_code}} / {{checkpoint().warning_response_code ?? '-'}}</span>
        </div>
        <div class="col">
            <div><strong>Retry</strong></div>
            <span>{{checkpoint().retries}}x / {{checkpoint().retry_delay | msReadable}}</span>
        </div>
        <div class="col">
            <div><strong>Interval</strong></div>
            <span>{{checkpoint().interval | msReadable}}</span>
        </div>
        <div class="col">
            <div><strong>SSL vervaldatum</strong></div>
            <span [class]="checkpoint()?.ssl_valid_till | sslValidUntil">{{(checkpoint().ssl_valid_till | daysFromNow) ?? '-'}}</span>
        </div>
        <div class="col">
            <div><strong>Opgeschort tot</strong></div>
            <span>{{(checkpoint().postponed_till | date:'EEE d MMM yyyy HH:mm') ?? '-'}}</span>
        </div>
        @if (Features.CheckpointsSave | hasFeature) {
            <div class="col">
                <div class="row justify-content-end pe-3">
                    <button mat-icon-button routerLink="/{{Routenames.seire}}/{{platform().id}}/store/{{checkpoint().id}}">
                        <mat-icon fontIcon="fa-edit" fontSet="fas"></mat-icon>
                    </button>
                </div>
            </div>
        }
    </div>
</div>
